import { useLoggedOut } from "@/components/user-context/helpers/cohorts";

import { SignupDefault } from "../components/signup-default";

import { LoggedOut } from "./logged-out";

export const StatuspageSignup = () => {
    const loggedOut = useLoggedOut();

    if (loggedOut) {
        return <LoggedOut />;
    }

    return <SignupDefault />;
};
